<template>
  <basic-container>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="批量查询" name="first">
        <avue-crud
          :option="option1"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          :permission="permissionList"
          v-model="form"
          ref="crud"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @on-load="onLoad"
          @refresh-change="onLoad"
        >
          <!--自定义查看按钮-->
          <template slot-scope="{ row }" slot="menu">
            <el-button
              type="text"
              icon="el-icon-view"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="handleDataScope1(row)"
              >查看
            </el-button>
            <el-button
              type="text"
              icon="el-icon-back"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="handleDataScopeRefund(row)"
              >退款
            </el-button>
          </template>
        </avue-crud>
        <!--查看详情弹出框-->
        <el-drawer
          :visible.sync="drawerVisible1"
          :direction="direction1"
          :before-close="handleDrawerClose1"
          :append-to-body="true"
          v-model="formScope1"
          size="1580px"
        >
          <!--交易订单表格-->
          <basic-container>
            <avue-crud :option="optionScope1" :table-loading="scopeLoading1" :data="dataScope1">
            </avue-crud>
          </basic-container>
          <!--交易订单详情表格-->
          <basic-container>
            <avue-crud
              :option="optionScope2"
              :table-loading="scopeLoading2"
              :data="dataScope2"
              :page="pageScope2"
              :permission="permissionList"
              v-model="formScope2"
              @current-change="currentChangeScope2"
              @size-change="sizeChangeScope2"
              @on-load="onLoadScope"
              @refresh-change="onLoadScope"
            >
            </avue-crud>
          </basic-container>
        </el-drawer>

        <!--退款详情弹出框-->
        <el-dialog
          title="退款申请"
          :visible.sync="drawerVisibleRefund"
          :append-to-body="true"
          width="30%"
          :before-close="handleDrawerCloseRefund">
          <el-form :model="formScopeRefund" label-width="100px" class="demo-ruleForm">
            <el-form-item label="商户订单号" prop="mchOrderNo">
              <el-input v-model="formScopeRefund.mchOrderNo" :readonly = "true"></el-input>
            </el-form-item>
            <el-form-item label="商品分类" prop="goodsType">
              <el-input v-model="formScopeRefund.goodsType" :readonly = "true"></el-input>
            </el-form-item>
            <el-form-item label="交易方式" prop="$payPlatform">
              <el-input v-model="formScopeRefund.$payPlatform" :readonly = "true"></el-input>
            </el-form-item>
            <el-form-item label="交易时间" prop="tradeTime">
              <el-input v-model="formScopeRefund.tradeTime" :readonly = "true"></el-input>
            </el-form-item>
            <el-form-item label="订单金额" prop="totalFee">
              <el-input v-model="formScopeRefund.totalFee" :readonly = "true"></el-input>
            </el-form-item>
            <el-form-item label="退款原因" prop="refundDesc">
              <el-input type="textarea" v-model="formScopeRefund.refundDesc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="commitRefund()">提交申请</el-button>
              <el-button @click="cancleRefund()">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-tab-pane>

      <el-tab-pane label="单笔查询" name="second">
        <avue-crud
          :option="option2"
          :table-loading="loading2"
          :data="data2"
          :page="page2"
          :permission="permissionList2"
          v-model="form2"
          ref="crud2"
          @search-change="searchChange2"
          @search-reset="searchReset2"
          @selection-change="selectionChange2"
          @current-change="currentChange2"
          @size-change="sizeChange2"
          @on-load="onLoad2"
          @refresh-change="onLoad2"
        >
          <!--自定义查看按钮-->
          <template slot-scope="{ row }" slot="menu">
            <el-button
              type="text"
              icon="el-icon-view"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="handleDataScope1(row)"
              >查看
            </el-button>
            <el-button
              type="text"
              icon="el-icon-back"
              size="small"
              plain
              style="border: 0; background-color: transparent !important;"
              @click.stop="handleDataScopeRefund(row)"
              >退款
            </el-button>
          </template>
        </avue-crud>
      </el-tab-pane>
    </el-tabs>
  </basic-container>
</template>

<script>
import { apply } from '@/api/v4ward/pay/payrefund';
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getPayTradeDetail,
} from '@/api/v4ward/pay/paytrade';
import { mapGetters } from 'vuex';
import option2 from '@/api/v4ward/pay/paytrade-option2';
import optionScope1 from '@/api/v4ward/pay/paytrademain-option';
import optionScope2 from '@/api/v4ward/pay/paytradedetail-option';
import optionScopeRefund from '@/api/v4ward/pay/paytradedetailrefund-option';

export default {
  data() {
    const date = new Date();
    let defaultEndTime = this.dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
    let defaultStartTime = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';

    return {
      activeName: 'first',
      form: {},
      form2: {},
      query: {},
      query2: {},
      loading: true,
      loading2: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      selectionList2: [],
      option1: {
        height: 'auto',
        calcHeight: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',

        viewBtn: false,
        selection: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,

        column: [
          {
            label: '交易时间',
            prop: 'tradeTime',
            search: true,
            type: 'datetime',
            searchRange: true,
            startPlaceholder: defaultStartTime,
            endPlaceholder: defaultEndTime,
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            searchSpan: 8,
            rules: [
              {
                required: true,
                message: '请输入交易时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '商户订单号',
            prop: 'mchOrderNo',
            rules: [
              {
                required: true,
                message: '请输入商户订单号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付渠道',
            prop: 'payPlatform',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=payChannel',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入支付渠道',
                trigger: 'change',
              },
            ],
          },
          // {
          //   label: '支付场景',
          //   prop: 'payScene',
          //   search: true,
          //   type: 'select',
          //   dicUrl: '/api/blade-system/dict/dictionary?code=payScene',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          //   dataType: 'number',
          //   width: 120,
          //   rules: [
          //     {
          //       required: false,
          //       message: '请输入支付场景',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            label: '商品分类',
            prop: 'goodsType',
            rules: [
              {
                required: true,
                message: '请输入商品分类',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交易状态',
            prop: 'tradeStatus',
            search: true,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=tradeStatus',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            width: 120,
            rules: [
              {
                required: true,
                message: '请输入交易状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '订单金额(元)',
            prop: 'totalFee',
            rules: [
              {
                required: true,
                message: '请输入订单金额(元)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '交易金额',
            prop: 'totalFeeStart',
            search: true,
            hide: true,
            searchSpan: 4,
            searchPlaceholder: '交易金额',
            rules: [
              {
                required: true,
                message: '请输入订单金额(元)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '至',
            prop: 'totalFeeEnd',
            search: true,
            hide: true,
            searchSpan: 4,
            searchLabelWidth: 30,
            searchPlaceholder: '交易金额',
            rules: [
              {
                required: true,
                message: '请输入订单金额(元)',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      option2: option2,
      data: [],
      data2: [],

      // 详情弹窗
      drawerVisible1: false,
      direction1: 'rtl',
      rowData: null,
      // 详情主表
      formScope1: {},
      scopeLoading1: false,
      optionScope1: optionScope1,
      dataScope1: [],

      // 详情明细
      formScope2: {},
      pageScope2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      scopeLoading2: false,
      optionScope2: optionScope2,
      dataScope2: [],
      selectionListScope2: [],

      //退款弹窗
      drawerVisibleRefund: false,
      directionRefund: 'rtl',
      formScopeRefund: {},
      optionScopeRefund: optionScopeRefund,
      selectionListScopeRefund: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.paytrade_add, false),
        viewBtn: this.vaildData(this.permission.paytrade_view, false),
        delBtn: this.vaildData(this.permission.paytrade_delete, false),
        editBtn: this.vaildData(this.permission.paytrade_edit, false),
      };
    },
    permissionList2() {
      return {
        addBtn: this.vaildData(this.permission.paytrade_add, false),
        viewBtn: this.vaildData(this.permission.paytrade_view, false),
        delBtn: this.vaildData(this.permission.paytrade_delete, false),
        editBtn: this.vaildData(this.permission.paytrade_edit, false),
      };
    },
  },
  methods: {
    handleClick(tab) {
      if (tab.name === 'first') {
        this.$refs.crud.searchReset();
      } else if (tab.name === 'second') {
        this.$refs.crud2.searchReset();
      }
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;

      let values = {
        ...this.query,
      };

      if (!values.tradeTime) {
        const date = new Date();
        values.tradeTimeEnd = this.dayjs(date).format('YYYY-MM-DD HH:mm:ss');
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        values.tradeTimeStart = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';
      }

      if (this.query.tradeTime) {
        values = {
          ...this.query,
          tradeTimeStart: this.query.tradeTime[0],
          tradeTimeEnd: this.query.tradeTime[1],
        };
        values.tradeTime = null;
      }

      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, values)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    searchReset2() {
      this.query2 = {};
      this.onLoad2();
    },
    searchChange2(params, done) {
      this.query2 = params;
      this.page2.currentPage = 1;
      this.onLoad2();
      done();
    },
    selectionChange2(list) {
      this.selectionList2 = list;
    },
    selectionClear2() {
      this.selectionList2 = [];
      this.$refs.crud2.toggleSelection();
    },
    currentChange2(currentPage) {
      this.page2.currentPage = currentPage;
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
    },
    onLoad2(page) {
      page = page || this.page2;
      let values = {
        ...this.query2,
      };
      if (!values.mchOrderNo) {
        const date = new Date();
        values.tradeTimeEnd = this.dayjs(date).format('YYYY-MM-DD HH:mm:ss');
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        values.tradeTimeStart = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';
      }

      this.loading2 = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, values)).then(
        ({ data }) => {
          this.page2.total = data.total;
          this.data2 = data.records;
          this.loading2 = false;
          this.selectionClear2();
        }
      );
    },

    //查看详情弹出框表格
    handleDataScope1(row) {
      this.drawerVisible1 = true;
      this.rowData = row;
      this.onLoadScope(row);
    },
    handleDrawerClose1(hide) {
      hide();
    },
    currentChangeScope2(currentPage) {
      this.pageScope2.currentPage = currentPage;
    },
    sizeChangeScope2(pageSize) {
      this.pageScope2.pageSize = pageSize;
    },
    onLoadScope(page) {
      //详情主表
      let data1 = [];
      data1.push(this.rowData);
      this.scopeLoading1 = true;
      this.dataScope1 = data1;
      this.scopeLoading1 = false;

      //详情明细表
      page = page || this.pageScope2;
      let paramDetail = { mchOrderNo: this.rowData.mchOrderNo };
      this.scopeLoading2 = true;
      getPayTradeDetail(
        Object.assign({ current: page.currentPage, size: page.pageSize }, paramDetail)
      ).then(({ data }) => {
        this.pageScope2.total = data.total;
        this.dataScope2 = data.records;
        this.scopeLoading2 = false;
      });
    },

    //退款弹出窗
    selectionChangeRefund(list) {
      this.selectionListScopeRefund = list;
    },
    selectionClearRefund() {
      this.selectionListScopeRefund = [];
      this.$refs.crudRefund.toggleSelection();
    },
    handleDataScopeRefund(row) {
      if(row.tradeStatus == 1){
        this.$message.warning('订单未支付，不能申请退款！');
        return;
      }
      if(row.tradeStatus == 4){
        this.$message.warning('订单已经全部退款，不能继续申请退款！');
        return;
      }
      this.drawerVisibleRefund = true;
      this.formScopeRefund = row;
    },
    cancleRefund() {
      this.drawerVisibleRefund = false;
    },
    commitRefund() {
      if (this.validatenull(this.formScopeRefund.refundDesc)) {
        this.$message.warning('请填写退款原因！');
        return;
      }
      console.log('param:' + JSON.stringify(this.formScopeRefund));
      apply(this.formScopeRefund).then(
        () => {
          this.drawerVisibleRefund = false;
          this.$message.success('操作成功!');
        },
        (error) => {
          console.log(error);
        }
      );
    },
    handleDrawerCloseRefund(hide) {
      hide();
    },

    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 9) {
        if (rowIndex % 10 == 0) {
          return {
            rowspan: 10,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
  },
};
</script>

<style scoped>
.avue-crud__menu {
  min-height: 0px;
}
.el-footer {
  text-align: center;
}
.el-main {
  padding: 0 20px !important;
}
</style>
